import { createBrowserRouter } from "react-router-dom";
import { RootLayoutWithToaster } from "@/layouts/RootLayout";
import ShowLayout from "@/layouts/ShowLayout";

// Pages
import HomePage from "@/pages/HomePage";
import LoginPage from "@/pages/login/LoginPage";
import SSOCallbackPage from "@/pages/sso/SSOCallbackPage";
import EpisodesPage from "@/pages/show/episodes/EpisodesPage";
import EpisodeScriptPage from "@/pages/show/episodes/episode/EpisodeScriptPage";
import InstructionsPage from "@/pages/show/InstructionsPage";
import SettingsPage from "@/pages/show/SettingsPage";
import AgentPage from "@/pages/show/AgentPage";
import AccountPage from "@/pages/show/AccountPage";
import CharactersPage from "@/pages/show/CharactersPage";
import AssetsPage from "@/pages/show/AssetsPage";
import StatisticsPage from "@/pages/show/StatisticsPage";
import Scene3DPage from "@/pages/show/Scene3DPage";

export const router = createBrowserRouter(
  [
    {
      element: <RootLayoutWithToaster />,
      children: [
        {
          path: "/",
          element: <HomePage />,
        },
        {
          path: "/login",
          element: <LoginPage />,
        },
        {
          path: "/sso",
          element: <SSOCallbackPage />,
        },
        {
          path: "/show",
          element: <ShowLayout />,
          children: [
            {
              path: "episodes",
              element: <EpisodesPage />,
            },
            {
              path: "episodes/:episodeId",
              element: <EpisodeScriptPage />,
            },
            {
              path: "instructions",
              element: <InstructionsPage />,
            },
            {
              path: "settings",
              element: <SettingsPage />,
            },
            {
              path: "agent",
              element: <AgentPage />,
            },
            {
              path: "account",
              element: <AccountPage />,
            },
            {
              path: "characters",
              element: <CharactersPage />,
            },
            {
              path: "assets",
              element: <AssetsPage />,
            },
            {
              path: "scene3d/new",
              element: <Scene3DPage />,
            },
            {
              path: "scene3d/:sceneId",
              element: <Scene3DPage />,
            },
            {
              path: "statistics",
              element: <StatisticsPage />,
            },
          ],
        },
      ],
    },
  ],
  { basename: import.meta.env.BASE_URL.replace(/\/$/, "") },
);
